import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import { getDataAtual, getDataFormatada, getData, getDataHoraBanco, getDataHoraFormatada } from '../utils/dataUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PRODUCAO_RACAO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = { datahora_producao: getDataAtual() }) {
    return [
        initialize('producaoRacaoForm', {
			...registro,
			datahora_producao: getDataHoraFormatada(registro.datahora_producao, 'DD/MM/YYYY HH:mm')
		})
    ];
}

export function getLista(id_empresa) {
    const request = axios.get(`${consts.API_URL}/producaoracao?id_empresa=${id_empresa}`);
    return {
        type: 'PRODUCAO_RACAO_LISTADO',
        payload: request
    };
}

export function getListaMateriaPrima(id_racao, id_empresa) {
    const request = axios.get(`${consts.API_URL}/racaoformula?id_racao=${id_racao || 0}&id_empresa=${id_empresa}`);
    return {
        type: 'PRODUCAO_RACAO_MATERIA_PRIMA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaGranja(id_empresa) {
    const request = axios.get(`${consts.API_URL}/granja/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'PRODUCAO_RACAO_GRANJA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaRacao(id_empresa) {
    const request = axios.get(`${consts.API_URL}/produto/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'PRODUCAO_RACAO_RACAO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaProducaoRacaoItem(id_producao_racao, id_empresa) {
	const request = axios.get(`${consts.API_URL}/producaoracaoitem?id_producao_racao=${id_producao_racao || 0}&id_empresa=${id_empresa}`);
    return {
        type: 'PRODUCAO_RACAO_ITEM_LISTADO',
        payload: request
    };
}

export function salvar(registro) {

    return (dispatch, getState) => {
        axios.post(`${consts.API_URL}/producaoracao`, {
			...registro,
			id_empresa: getState().auth.usuario.id_empresa,
			datahora_producao: getDataHoraBanco(registro.datahora_producao)
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(getState().auth.usuario.id_empresa));
            dispatch(setModoTela('lista'));
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/producaoracao?id=${registro.id}`)
            .then(resp => {
                setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(getState().auth.usuario.id_empresa));
                dispatch(setModoTela('lista'));
            })
            .catch(e => {
                setErroAPI(e);
            });
    };
}
